import React from "react";
import styled from "styled-components";
import gyeongwonLogo from "../../../../assets/images/gyunwonlogo.png";
import backgroundIntroductionSimple from "../../../../assets/images/Background/Introduction_simple.png";
import backgroundIntroductionModern from "../../../../assets/images/Background/Introduction_modern.png";
import backgroundDeliverySimple from "../../../../assets/images/Background/delivery_simple.png";
import backgroundDeliveryModern from "../../../../assets/images/Background/delivery_modern.png";
import backgroundGuideSimple from "../../../../assets/images/Background/guide_simple.png";
import backgroundGuideModern from "../../../../assets/images/Background/guide_modern.png";
import backgroundOpinionSimple from "../../../../assets/images/Background/opinion_simple.png";
import backgroundOpinionModern from "../../../../assets/images/Background/opinion_modern.png";
import backgroundPromotionalSimple from "../../../../assets/images/Background/promotional_simple.png";
import backgroundPromotionalModern from "../../../../assets/images/Background/promotional_modern.png";

import Markdown from "markdown-to-jsx";

const MoleculeBackgroundSimple = ({ contentsPurpose, title, content }) => {
  console.log("contentsPurpose", contentsPurpose);

  const backgroundImage = () => {
    if (!contentsPurpose || contentsPurpose === "") {
      return backgroundIntroductionSimple; // 기본 이미지
    }

    // 문자열 정규화 후 매칭
    const normalizedPurpose = contentsPurpose.trim();

    if (normalizedPurpose.includes("정보전달형")) {
      return backgroundIntroductionSimple;
    }
    if (normalizedPurpose.includes("프로그램 안내형")) {
      return backgroundDeliverySimple;
    }
    if (normalizedPurpose.includes("행사/대회 홍보형")) {
      return backgroundGuideSimple;
    }
    if (normalizedPurpose.includes("의견수렴형")) {
      return backgroundOpinionSimple;
    }
    if (normalizedPurpose.includes("창의활동/문화활동 소개형")) {
      return backgroundPromotionalSimple;
    }

    // 기본 이미지 반환
    return backgroundIntroductionSimple;
  };

  const preprocessedContent = content ? content.replace(/\n/g, "<br/>") : null;

  return (
    <StyledSlide16925>
      <StyledContainer>
        <StyledTitleArea>
          {title && (
            <StyledTitle>
              {Array.isArray(title)
                ? title.map((line, index) => <div key={index}>{line}</div>)
                : title}
            </StyledTitle>
          )}
        </StyledTitleArea>
        <StyledContentArea>
          <StyledContent>
            {preprocessedContent ? (
              <Markdown>{preprocessedContent}</Markdown>
            ) : null}
          </StyledContent>
        </StyledContentArea>
      </StyledContainer>
      <StyledLogoArea>
        <StyledLogoImage src={gyeongwonLogo} alt="경원중학교 로고" />
      </StyledLogoArea>
      <StyledImageArea backgroundImage={backgroundImage()} />
    </StyledSlide16925>
  );
};

export default MoleculeBackgroundSimple;

const StyledContainer = styled.div`
  /* position: absolute; */
  /* left: 108px; */
  /* top: 0; */
  /* bottom: 103px; */
  /* right: 388px; */
  height: 1920px;
  padding-top: 134px;
  padding-left: 108px;
  padding-bottom: 108px;
  display: flex;
  flex-direction: column;
`;

const StyledTitleArea = styled.div`
  width: 660px;
  flex-shrink: 0;
`;

const StyledTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-family: Pretendard;
  font-size: 80px;
  line-height: 1.35;
  font-weight: 800;
  color: black;
  text-align: start;
`;

const StyledContentArea = styled.div`
  width: 660px;
  height: calc(1920px - 216px - 360px);

  margin-top: auto;
  margin-bottom: 0;
  flex-shrink: 0;
  text-align: start;

  z-index: 99999;
`;

const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  font-family: Pretendard;
  font-size: 32px;
  line-height: 1.5;
  color: black;
  overflow-y: auto;
  display: flex;
  align-items: left;
  justify-content: center;
  flex-direction: column;
  text-align: start;
`;

const StyledImageArea = styled.div`
  width: 380px;
  height: 1920px;
  right: 0;
  top: 0;
  position: absolute;
  background: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : "#D9D9D9"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const StyledLogoArea = styled.div`
  width: 250px;
  height: 56px;
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const StyledSlide16925 = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: white;
  overflow: hidden;
`;
